import React, { useState, useEffect } from "react";
import HyperTextIcon from "../HyperTextIcon/HyperTextIcon";
import ToolTip from "../../ToolTip/ToolTip";
import DelIcon from "../DelIcon/DelIcon";
import "../../Styles/globalStyle.css";
import SortCommand from "../SortCommand/SortCommand";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function HyperText(props) {
  const [isDragOver, setDragover] = useState(false);
  const [isShowToolTip, setIsShowToolTip] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getStyle = () => {
    var newStyle = buildStyle(props.style);

    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" :
      props.errors ? props.errors.border : props.style.border.value;
    return newStyle;
  };

  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  return (
  <React.Fragment>
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onDrop={(e) => props.onlyLabel && onDropColumn(e)}
      onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
      onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
      onClick={(e) => props.onClick(e)}
      onMouseLeave={(e) => props.onMouseLeave(e)}
      //onMouseOver={(e) => props.onMouseOver(e)}
      onMouseEnter={(e) => props.onMouseEnter(e)}
      onMouseDown={(e) => props.onMouseDown(e)}
      style={getStyle()}
      id={props.data.id}
      
    >
      {!props.onlyLabel && (
        <div
          style={{
            height: "25px",
            userSelect: "none",
            paddingTop: 3,
          }}
        >
          <HyperTextIcon />
        </div>
      )}
      <div
        className="label cutText"
        onMouseOver={() => setIsShowToolTip(true)}
        onMouseLeave={() => setIsShowToolTip(false)}
      >
        <span
          style={{
            userSelect: "none",

            fontSize: props.style.fontSize.value,
          }}
        >
          {props.data.properties.text.value}
        </span>
        {/*!props.onlyLabel && (
          <ToolTip
            canShowToolTip={isShowToolTip}
            text={props.data.properties.text.value}
          />
        )*/}
      </div>
      {props.onlyLabel ? (
        props.sortable && <SortCommand />
      ) : (
        <div
          style={{
            lineHeight: "auto",
            marginLeft: "auto",
            userSelect: "none",
          }}
        >
          <DelIcon />
        </div>
      )}
       
    </div>
    {props.errors && !props.errors.isColumn &&  <input readOnly style={props.errors.styles} value={props.errors.value} />}
  </React.Fragment>
  );
}
